import React, { Component, useState } from 'react';
import './chat.css';
import { Fragment } from 'react';
import authService from './../api-authorization/AuthorizeService';
import Moment from 'react-moment';
import { Modal } from 'react-bootstrap';


export class PresenterRequests extends Component {
    constructor(props) {
        super(props)

        this.VmeetingId = parseInt(sessionStorage.getItem('VMId'));
        this.UserId = parseInt(sessionStorage.getItem('UserId'));

        this.state = {
            loading: true,
            requestData: [],
            dataFound: false
        };

    }

    async componentDidMount() {
        this.populateData();
    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.populateData();
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    populateData = () => {

        this.setState({
            dataFound: this.props.dataFound,
            requestData: this.props.requestData.filter(request => request.ready && !request.complete).sort((a, b) => a.readyAt > b.readyAt ? 1 : -1),
            loading: this.props.loading
        })


    }



    render() {
        if (this.state.loading) {
            return (
                <div className="chatloaderholder"><div className="loader" /></div>
            )
        } else if (!this.state.dataFound || this.state.requestData.length === 0) {
            return (
                <Fragment>
                    <div className="SeenAndHeard">
                        <div className="chat-heading">REQUESTS</div>
                        <div className="mx-3">
                            <p> No requests found </p>
                        </div>
                    </div>
                </Fragment >
            )
        }
        return (
            <Fragment>
                <div className="chat-heading">REQUESTS</div>
                <div className="SeenAndHeard">
                    {this.state.requestData.map((request) => <DisplayContent request={request} key={request.id} />)}

                </div>
            </Fragment>
        );
    }
}

function DisplayContent(props) {
    const [showModal, setShowModal] = useState(false);

    const returnKey = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            setShowModal(true);
        }
    }

    let request = props.request;
    return (
        <Fragment>
            <div className="presenterRequest border rounded m-1 p-1"
                onClick={() => setShowModal(true)}
                onKeyDown={(e) => returnKey(e)}
                role="button"
                tabIndex="0">
                <div className="border-bottom d-flex justify-content-between">
                    <div className="inbox4 fw-bold">From: {request.userName}</div>
                    <div><Moment format="D MMM HH:mm:ss" date={request.readyAt} /></div>
                </div>
                <div className="fw-bold">{request.questionType}</div>
                <div className="messageText">{request.questionText}</div>
            </div>
            <DisplayRequestModal
                show={showModal}
                onHide={() => setShowModal(false)}
                request={props.request}
            />
        </Fragment>
    )
}


function DisplayRequestModal(props) {
    let request = props.request;
    return (
        <Modal
            {...props}
            dialogClassName="modal-65w"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <div className="d-flex justify-content-between">
                        <div className="inbox4 fw-bold">{request.userName}: {request.questionType}</div>
                        <div><Moment format="D MMM HH:mm:ss" date={request.readyAt} /></div>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="m-1 px-2">
                    <div className="messageText fs-3">{request.questionText}</div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={props.onHide}>Close</button>
            </Modal.Footer>
        </Modal>
    );
}
